import * as braintree from 'braintree-web'

import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const savePayPalExpressCheckoutPersonalInfo: CheckoutActionCreator = ({
  firstName,
  lastName,
  phone,
}: braintree.PayPalTokenizePayload['details']) => ({
  type: actionTypes.SAVE_PAYPAL_EXPRESS_CHECKOUT_PERSONAL_INFO,
  personalInfo: {
    firstName,
    lastName,
    phoneNumber: phone,
  },
})
